import { connect } from 'react-redux'
import CadastroCnpjModal from './modal';

export default connect()(CadastroCnpjModal);
